import React from 'react';
import Select, { MultiValue, StylesConfig } from 'react-select';
import { InputFieldWithTitles } from '../../../../components/UI-Elements/Select/InputFieldWithTitles';
import { OptionSelect } from '../../../../components/UI-Elements/Select/OptionSelect';
import { Material } from '../../../../sp-types/materialType';
import { ProductMeasureTypes } from '../../../../sp-types/productType';

export interface IProductFilters {
  id?: string;
  name?: string;
  measureType?: string;
  category?: string;
  subCategory?: string;
  materials?: string[];
}

interface IProductFilterSectionProps {
  filters: IProductFilters;
  setFilters: React.Dispatch<React.SetStateAction<IProductFilters>>;
  categories: Record<string, string[]>;
  materialsMap: Record<string, Material>;
}

export const ProductFilterSection: React.FC<IProductFilterSectionProps> = ({
  filters,
  setFilters,
  categories,
  materialsMap,
}) => {
  const materialOptions = Object.values(materialsMap).map(({ id, name }) => ({
    value: id,
    label: name,
  }));

  const customStyles: StylesConfig<{ value: string; label: string }, true> = {
    control: (provided) => ({
      ...provided,
      minHeight: '28px',
      height: '28px',
      overflow: 'auto',
      alignContent: 'center',
      fontSize: '14px',
      paddingTop: '0px',
      paddingBottom: '0px',
      boxShadow: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#6571FF',
      '&:hover': {
        color: 'darkblue',
      },
    }),
  };

  const handleMaterialChange = (selected: MultiValue<{ value: string; label: string }>) => {
    const selectedMaterials = selected.map((option) => option.value);
    setFilters({ ...filters, materials: selectedMaterials });
  };

  return (
    <div className=" bg-gray-100 shadow-custom py-2 px-3  grid grid-cols-13  gap-4 pe-2 border border-gray-300 me-3 h-[5rem] overflow-hidden">
      <div className="col-span-1 truncate   ">
        <InputFieldWithTitles
          subtitle="Product ID"
          placeHolder="all"
          value={filters.id || ''}
          changeValueFunc={(value: string | number) => setFilters({ ...filters, id: value.toString() })}
        />
      </div>
      <div className="col-span-2 truncate  ">
        <InputFieldWithTitles
          subtitle="Product Name"
          placeHolder="all"
          value={filters.name || ''}
          changeValueFunc={(value: string | number) => setFilters({ ...filters, name: value.toString() })}
        />
      </div>
      <div className="col-span-1 truncate   ">
        <OptionSelect
          subtitle="Measure by"
          placeHolder="All"
          options={[...ProductMeasureTypes]}
          currentOption={filters.measureType || ''}
          setCurrentOption={(value: string | number) => setFilters({ ...filters, measureType: value.toString() })}
        />
      </div>
      <div className="col-span-1 truncate  flex flex-row  ">
        <OptionSelect
          subtitle="Category"
          placeHolder="All"
          options={Object.keys(categories)}
          currentOption={filters.category || ''}
          setCurrentOption={(value: string | number) =>
            setFilters({ ...filters, category: value.toString(), subCategory: '' })
          }
        />
      </div>
      <div className="col-span-1 truncate    ">
        <OptionSelect
          subtitle="Sub Category"
          placeHolder="All"
          disabled={!filters.category}
          isEditable={!!filters.category}
          options={filters.category ? categories[filters.category] : []}
          currentOption={filters.subCategory || ''}
          setCurrentOption={(value: string | number) => setFilters({ ...filters, subCategory: value.toString() })}
        />
      </div>
      <div className="col-span-4 overflow-auto z-20 flex flex-col flex-1  gap-2  ">
        <p className="text-sm text-secondary_text">Select materials</p>
        <Select
          menuPosition="fixed"
          pageSize={5}
          isMulti
          value={materialOptions.filter((option) => filters.materials?.includes(option.value))}
          onChange={handleMaterialChange}
          options={materialOptions}
          styles={customStyles}
        />
      </div>
    </div>
  );
};
